// extracted by mini-css-extract-plugin
export default {"container":"tooltipTextBubble_container__KV6i0","bubble":"tooltipTextBubble_bubble__CtwEz"};